import React from 'react';

import { Flex } from '@ttoss/ui';
import { ThemeUIStyleObject } from '@theme-ui/css';

type ToggleSelect = 'left' | 'right';

export type ToggleButtonProps = {
  leftButton: {
    onClick: () => void;
    label: string;
  };
  rightButton: {
    onClick: () => void;
    label: string;
  };
  initialSelected?: ToggleSelect;
  sx?: ThemeUIStyleObject;
};

const ToggleButton = ({
  leftButton,
  rightButton,
  initialSelected = 'left',
  sx,
}: ToggleButtonProps) => {
  const [selected, setSelected] = React.useState<ToggleSelect>(initialSelected);

  const handleClick = (toggleSelected: ToggleSelect) => {
    setSelected(toggleSelected);

    if (toggleSelected === 'left') {
      leftButton.onClick();
    } else {
      rightButton.onClick();
    }
  };

  const defaultSxProps = {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    cursor: 'pointer',
  };

  const { leftSelected, rightSelected } = React.useMemo(() => {
    return {
      leftSelected: selected === 'left',
      rightSelected: selected === 'right',
    };
  }, [selected]);

  return (
    <Flex
      className="toggle-button"
      sx={{
        borderColor: 'secondary',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 'partial',
        height: '29px',
        width: 'fit-content',
        overflow: 'hidden',
        fontFamily: 'heading',
        fontSize: 3,
        ...sx,
      }}
    >
      <Flex
        sx={{
          ...defaultSxProps,
          backgroundColor: leftSelected ? 'secondary' : 'background',
          color: leftSelected ? 'background' : 'secondary',
        }}
        onClick={() => handleClick('left')}
      >
        {leftButton.label}
      </Flex>

      <Flex
        sx={{
          ...defaultSxProps,
          backgroundColor: rightSelected ? 'secondary' : 'background',
          color: rightSelected ? 'background' : 'secondary',
        }}
        onClick={() => handleClick('right')}
      >
        {rightButton.label}
      </Flex>
    </Flex>
  );
};

export default ToggleButton;
